// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1dprl","sendOtp":"AuthorizeToLogin_sendOtp__1q8tJ"};